import type React from 'react';
import classes from './assignment-list.module.scss';
import type { ShiftHomeAssignment } from '../../../../models/home.types';
import { formatAssignmentDayLabel } from '../../../../utils/date.utils';

export const AssignmentList: React.FC<{ assignments: ShiftHomeAssignment[] }> = ({ assignments }) => (
  <ul className={classes.assignmentList}>
    {assignments.map((assignment) => (
      <li key={assignment.slotId} className={classes.assignmentItem}>
        <div className={classes.assignmentTopRow}>
          <span className={classes.assignmentDayLabel}>{formatAssignmentDayLabel(assignment.dateDay)}</span>
          <span className={classes.assignmentTimeLabel}>
            {assignment.startHour} - {assignment.endHour}
          </span>
        </div>
        <div className={classes.assignmentMetaRow}>
          <span>{assignment.sectionName}</span>
          <span className={classes.assignmentSeparator}>•</span>
          <span>{assignment.shiftName}</span>
          <span className={classes.assignmentSeparator}>•</span>
          <span>{assignment.roleName}</span>
        </div>
      </li>
    ))}
  </ul>
);
